import { memo } from 'react';
import { CopyBlock, googlecode } from 'react-code-blocks';
import LargePayloadBlock, { isOversizedPayload } from '@/features/troubleshooting/LargePayloadBlock.jsx';

const TracerCodeBlock = ({ code, language }) => {
  return (
    <div
      style={{
        fontFamily: 'Fira Code, monospace',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'start',
        alignItems: 'center',
      }}
    >
      {isOversizedPayload(code) ? (
        <LargePayloadBlock text={code} height="350px" label="error message" />
      ) : (
        <div style={{ background: googlecode.backgroundColor, paddingBottom: '1em' }}>
          <CopyBlock
            codeBlock
            text={code}
            language={language}
            showLineNumbers={false}
            startingLineNumber={0}
            codeBlockStyle={{ whiteSpace: 'break-spaces', overflowWrap: 'break-word', wordWrap: 'break-word' }}
            codeContainerStyle={{
              whiteSpace: 'break-spaces',
              wordWrap: 'break-word',
            }}
            customStyle={{
              whiteSpace: 'break-spaces',
              height: '350px',
              width: '100%',
              overflowY: 'scroll',
              margin: '0px 0.75rem',
              borderRadius: '0.25rem',
              boxShadow: '1px 2px 3px rgba(0, 0, 0, 0, 0.35)',
              fontSize: '0.75rem',
            }}
            theme={googlecode}
          />
        </div>
      )}
    </div>
  );
};
export default memo(TracerCodeBlock);
